import { createContext, useContext, useState } from 'react';
import english from './en.json';

const LanguageContext = createContext(null);
const STORAGE_KEY = 'squaregolf-cs-language';

function readLanguage() {
  try {
    return localStorage.getItem(STORAGE_KEY) === 'en' ? 'en' : 'ko';
  } catch {
    return 'ko';
  }
}

export function translate(text, language) {
  return language === 'en' ? english[text] ?? text : text;
}

export function LanguageProvider({ children }) {
  const [language, setLanguage] = useState(readLanguage);

  const changeLanguage = (nextLanguage) => {
    if (!['ko', 'en'].includes(nextLanguage)) return;
    setLanguage(nextLanguage);
    try {
      localStorage.setItem(STORAGE_KEY, nextLanguage);
    } catch {
      // Language selection still works when browser storage is unavailable.
    }
  };

  return (
    <LanguageContext.Provider value={{ language, changeLanguage, t: (text) => translate(text, language) }}>
      {children}
    </LanguageContext.Provider>
  );
}

export function useLanguage() {
  return useContext(LanguageContext);
}
